import { useSnapshot } from "valtio"
import Select from 'react-select'
import { useState, useEffect } from "react"
import { EntityV2Store } from "../state/CommonState"
import { FormControl, Grid } from "@mui/material"
import { Controller } from "react-hook-form"

const customStyles = {
    control: (provided) => ({
        ...provided,
        minHeight: '30px',
        border: '1px solid #ccc',
    }),

    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        display: 'none',
    }),
    option: (provided) => ({
        ...provided,
        height: '30px',
        background: '#fff',
        color: '#363636'
    }),
}

const customStyles1 = {
    control: (provided) => ({
        ...provided,
        minHeight: '30px',
        border: '1px solid #ccc',
    }),

    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        display: 'none',
    }),
    option: (provided) => ({
        ...provided,
        background: '#fff',
        color: '#363636'
    }),
}

export default function AgCustlist({ label, record, name, dataList, callback = f => f , isValid = true, validationMsg, isDisabled }) {
    const [selectedOption, setSelectedOption] = useState(null)
    const imRecord = useSnapshot(record)
    useEffect(() => {
        let entityList = dataList.filter((ele) => ele.entityId === imRecord['entityId'])
        setSelectedOption(entityList)
    }, [dataList, imRecord, name])
    return (
        <div className="field">
            <label className="label is-small" style={{ marginBottom: '0px' }}>{label}</label>
            <div className="control">
                <div className={ isValid ? "label is-small" : "label is-small is-danger"}>
                    {
                        dataList !== null ? <Select
                            value={selectedOption}
                            options={dataList}
                            onChange={(e) => {
                                record[name] = e ? e.entityId : ""
                                setSelectedOption(e)
                                callback(e ? e.entityId : "")
                            }}
                            getOptionLabel={(entityList) => {
                                if(entityList.state == undefined || entityList.state == "undefined"){
                                    return entityList.entityName
                                }else{
                                   return entityList.entityName+" "+entityList.state
                                }
                            }}
                            isDisabled={!isDisabled || !isDisabled.disabled ? false : isDisabled.disabled }
                            isSearchable={true}
                            isClearable={true}
                            placeholder={null}
                            styles={customStyles}

                        /> : ""
                    }

                </div>
            </div>
            { !isValid &&  <p class="help is-danger"> { validationMsg || `* Please select one customer` }</p> }
        </div>
    )
}
export function AgCustlistInvoice({
  label,
  callback = (f) => f,
  isValid = true,
  validationMsg,
  isDisabled,
  value,
  dataList
}) {
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    if (dataList && value) {
      const entity = dataList.find((ele) => ele.entityId === value);
      setSelectedOption(entity || null);
    } else {
      setSelectedOption(null);
    }
  }, [dataList, value]);

  return (
    <>
          <td>
                <div style={{ marginRight: '5px', marginTop: '3px' }}>{label}</div>
        </td>
      
        <td colSpan={3}><div className="control" style={{ flex: 1, border: !isValid ? '1px solid red' : '', borderRadius: '4px' }}>
          {dataList ? (
            <Select
              value={selectedOption}
              options={dataList}
              onChange={(e) => {
                if (!e) {
                  setSelectedOption(null);
                  callback(null);
                  return;
                }

                setSelectedOption(e);
                callback(e);
              }}
              getOptionLabel={(entity) =>
                entity?.state
                  ? `${entity.entityName} ${entity.state}`
                  : entity.entityName
              }
              isDisabled={isDisabled?.disabled ?? false}
              isSearchable
              isClearable
              placeholder=""
              styles={customStyles}
            />
          ) : null}
        </div>
      </td></>
  );
}


export function AgCustlistCH({ label, name, callback = f => f , isValid = true, validationMsg, isDisabled, value, dataList , borderHighlight ,control , rules , width}) {
    const [selectedOption, setSelectedOption] = useState(null)
    const [val, setVal] = useState(value)
    useEffect(() => {
        if(dataList!=undefined){
            if(val!=undefined && val.length!=0){
                let entityList = dataList.filter((ele) => ele.entityId === val)
                setSelectedOption(entityList)
            }
        }
    }, [dataList, val, name])
    return (
   
        <FormControl sx={{ width: width || "100%", height: "100%", gap: 0 }}>
                  <Controller
                   control={control}
                   name={name}
                   rules={rules}    
                    render={({field,fieldState}) =>  <Grid container columnSpacingSpacing={label?"4px":0} direction="column"    >
            <label className="label is-small" style={{ marginBottom: '0px' }}>{label}</label>
            <div className="control" style={{border: (!isValid && borderHighlight )? '1px solid red' : '', borderRadius: '4px' }}>
                <div className={ isValid ? "label is-small" : "label is-small is-danger"}>
                    {
                        dataList !== null ? <Select
                            value={selectedOption}
                            options={dataList}
                            onChange={(e) => {
                                setVal(e ? e.entityId : "")
                                setSelectedOption(e)
                                callback(e ? e.entityId : "")
                            }}
                            getOptionLabel={(entityList) => {
                                if(entityList.state == undefined || entityList.state == "undefined"){
                                    return entityList.entityName
                                }else{
                                   return entityList.entityName+" "+entityList.state
                                }
                            }}
                            isDisabled={!isDisabled || !isDisabled.disabled ? false : isDisabled.disabled }
                            isSearchable={true}
                            isClearable={true}
                            placeholder={null}
                            styles={customStyles}

                        /> : ""
                    }

                </div>
            </div>
            </Grid>}/>
            { !isValid &&  <p class="help is-danger"> { validationMsg || `* Please select one customer` }</p> }
            </FormControl>
       
    )
}

export function AgSelectNewCH({ label, name, dataList, callback = f => f , isValid = true, validationMsg, value, isDisabled,placeholder   }) {
    const [selectedOption, setSelectedOption] = useState(null)
    const [val, setVal] = useState(value)
    useEffect(() => {
        if(dataList!=undefined){
            if(value!=undefined && value.length!=0 ||(value!=undefined && name === "salesperson" && value === "") ||( value!=undefined && name === "customerService" && value === "") ){
                let v = dataList.filter((ele) => ele.value === value)
                console.log(v)
                setSelectedOption(v)
            }
        }
    }, [JSON.stringify(dataList), val, name, value])
    return (
        <div className="field">
            <label className="label is-small" style={{ marginBottom: '0px' }}>{label}</label>
            <div className="control" style={{border: !isValid ? '1px solid red' : '', borderRadius: '4px' }}>
                <div className={ isValid ? "label is-small" : "label is-small is-danger"}>
                    {
                        dataList !== null ? <Select
                            value={selectedOption}
                            options={dataList}
                            onChange={(e) => {
                                setVal(e ? e.value : "")
                                setSelectedOption(e)
                                callback(e ? e.value : "")
                            }}
                            getOptionLabel={(e) => {
                                return e.label
                            }}
                            isDisabled={!isDisabled || !isDisabled.disabled ? false : isDisabled.disabled }
                            isSearchable={true}
                            isClearable={true}
                            placeholder={placeholder?placeholder:null}
                            styles={customStyles1}

                        /> : ""
                    }

                </div>
            </div>
            { !isValid &&  <p class="help is-danger"> { validationMsg || `* Please select one customer` }</p> }
        </div>
    )
}

export function AgSelectLatestCH({ label, name, dataList, callback = f => f , isValid = true, validationMsg, value, isDisabled,placeholder ,control , rules , width   }) {
    const [selectedOption, setSelectedOption] = useState(null)
    const [val, setVal] = useState(value)
    useEffect(() => {
        if(dataList!=undefined){
            if(value!=undefined && value.length!=0 ||(value!=undefined && name === "salesperson" && value === "") ||( value!=undefined && name === "customerService" && value === "") ){
                let v = dataList.filter((ele) => ele.value === value)
                console.log(v)
                setSelectedOption(v)
            }
        }
    }, [JSON.stringify(dataList), val, name, value])
    return (
       
                <FormControl sx={{  width:width || "100%",height:"100%",gap:0 }}>
                  <Controller
                   control={control}
                   name={name}
                   rules={rules}    
                    render={({field,fieldState}) =>  <Grid container columnSpacingSpacing={label?"4px":0} direction="column"    >
            <label className="label is-small" style={{ marginBottom: '0px' }}>{label}</label>
            <div className="control" style={{border: !isValid ? '1px solid red' : '', borderRadius: '4px' }}>
                <div className={ isValid ? "label is-small" : "label is-small is-danger"}>
                    {
                        dataList !== null ? <Select
                            value={selectedOption}
                            options={dataList}
                            onChange={(e) => {
                                setVal(e ? e.value : "")
                                setSelectedOption(e)
                                callback(e ? e.value : "")
                            }}
                            getOptionLabel={(e) => {
                                return e.label
                            }}
                            isDisabled={!isDisabled || !isDisabled.disabled ? false : isDisabled.disabled }
                            isSearchable={true}
                            isClearable={true}
                            placeholder={placeholder?placeholder:null}
                            styles={customStyles1}

                        /> : ""
                    }

                </div>
            </div>
            </Grid>}/>            
            
            { !isValid &&  <p class="help is-danger"> { validationMsg || `* Please select one customer` }</p> }
            </FormControl>
       
    )
}





export function AgSelectNew({ label, record, name, dataList, callback = f => f , isValid = true, validationMsg, isDisabled }) {
    const [selectedOption, setSelectedOption] = useState(null)
    const imRecord = useSnapshot(record)
    useEffect(() => {
        let value = dataList.filter((ele) => ele.value === imRecord[name])
        setSelectedOption(value)
    }, [dataList, imRecord, name])
    return (
        <div className="field">
            <label className="label is-small" style={{ marginBottom: '0px' }}>{label}</label>
            <div className="control" style={{ border: !isValid ? '1px solid red' : '', }}>
                <div className="label is-small" >
                    {
                        dataList !== null ? <Select
                            value={selectedOption}
                            options={dataList}
                            onChange={(e) => {
                                record[name] = e ? e.value : ""
                                setSelectedOption(e)
                                callback(e ? e.value : "")
                            }}
                            getOptionLabel={(e) => {
                                return e.label
                            }}
                            isDisabled={!isDisabled || !isDisabled.disabled ? false : isDisabled.disabled }
                            isSearchable={true}
                            isClearable={true}
                            placeholder={null}
                            styles={customStyles1}

                        /> : ""
                    }

                </div>
            </div>
            { !isValid &&  <p class="help is-danger"> { validationMsg || `* Please select one customer` }</p> }
        </div>
    )
}
/*
export default function AgCustlist({ label, record, name, dataList, callback = f => f }) {
    const imRecord = useSnapshot(record)
    return (
        <div className="field">
            <label className="label is-small" style={{ marginBottom: '0px' }}>{label}</label>
            <div className="control">
                <div className="select is-small">
                    <select name={name} value={imRecord[name]}
                        onChange={(e) => {
                            console.log('FROM INSIDE AgCustlist=', record, e.target.value)
                            record[name] = e.target.value
                            callback(e.target.value)
                        }} >
                        {dataList.map(val => <option value={val.key}>{val.value}</option>)}
                    </select>
                </div>
            </div>
        </div>
    )
}
*/